<section class="background-color-nearwhite">
    <div class="container">
        <h1 [innerHTML]="'booking.bookingConfirmation.title' | translate"></h1>
        <p *ngIf="directBookingList && directBookingList.length === 0 && onlineRequestList && onlineRequestList.length > 0" class="intro" [innerHTML]="'booking.bookingConfirmation.introIfOnlyOnlineRequestWereBooked' | translate"></p>
        <p *ngIf="directBookingList && directBookingList.length > 0 && onlineRequestList && onlineRequestList.length === 0" class="intro" [innerHTML]="'booking.bookingConfirmation.introIfOnlyDirectBookingWereBooked' | translate"></p>
        <p *ngIf="directBookingList && directBookingList.length > 0 && onlineRequestList && onlineRequestList.length > 0" class="intro" [innerHTML]="'booking.bookingConfirmation.introIfDirectBookingAndOnlineRequestWereBooked' | translate"></p>
    </div>
        <div *ngIf="directBookingList && directBookingList.length > 0" class="container">
        <h3><span [innerHTML]="'booking.bookingConfirmation.directBookingLabel' | translate"></span></h3>
        <ul class="booking-list">
            <li *ngFor="let directBookedCourse of directBookingList">{{directBookedCourse.title}}<br><span>{{directBookedCourse.participantFirstName}} {{directBookedCourse.participantLastName}}</span></li>
        </ul>
    </div>
    <div *ngIf="onlineRequestList && onlineRequestList.length > 0" class="container">
        <h3><span [innerHTML]="'booking.bookingConfirmation.onlineRequestLabel' | translate"></span></h3>
        <ul class="booking-list">
            <li *ngFor="let onlineRequestedCourse of onlineRequestList">{{onlineRequestedCourse.title}}<br><span>{{onlineRequestedCourse.participantFirstName}} {{onlineRequestedCourse.participantLastName}}</span></li>
        </ul>
    </div>
    <div *ngIf="failingCourseList && failingCourseList.length > 0" class="container hint-box">
        <h3><span [innerHTML]="'booking.bookingConfirmation.failedBookingLabel' | translate"></span></h3>
        <ul class="failing-course-items-list">
            <li *ngFor="let failingCourse of failingCourseList">{{failingCourse.title}}<br><span>{{failingCourse.participantFirstName}} {{failingCourse.participantLastName}}</span></li>
        </ul>
        <p [innerHTML]="'booking.bookingConfirmation.pleaseContactText' | translate"></p>
    </div>
</section>

<section class="background-color-white" *ngIf="events$ | async as events">
    <div class="container" *ngIf="events.length > 0">
        <da-hotels-list [events]="events"></da-hotels-list>
    </div>
</section>
